import { format, getDay, subMonths } from 'date-fns'
import React, { FC, useCallback } from 'react'

import { useTranslation } from '@Globals/Translations'

export const OrderBeforeText: FC = () => {
  const { t } = useTranslation()

  const isWintertime = useCallback((date) => {
    const standardOffset = new Date(date).getTimezoneOffset()
    const daylightOffset = new Date(subMonths(date, 6)).getTimezoneOffset()
    return standardOffset === daylightOffset
  }, [])

  const getShowOrderBeforeText = useCallback(() => {
    const isWinterTime = isWintertime(new Date())
    let shipIsToday = false
    let shipIsTomorrow = false
    let showOrderBeforeText = true

    const denmarkShippingEndHour = 16

    const denmarkNow = new Date((new Date()).toLocaleString('en-US', { timeZone: 'Europe/Copenhagen' }))

    const denmarkHour = parseInt(format(denmarkNow, 'H'), 10)
    const denmarkDay = getDay(denmarkNow)

    const localNow = new Date()
    const localHour = parseInt(format(localNow, 'H'), 10)

    const hoursRemaining = denmarkShippingEndHour - denmarkHour
    const localShippingEndHour = localHour + hoursRemaining

    if (localShippingEndHour > 24 || denmarkHour >= denmarkShippingEndHour) { shipIsTomorrow = true } else { shipIsToday = true }

    if (shipIsToday && hoursRemaining > 12) { showOrderBeforeText = false }

    if (shipIsTomorrow && denmarkDay >= 5) { showOrderBeforeText = false }

    if (!showOrderBeforeText) {
      return null
    }

    if (shipIsToday) {
      return isWinterTime
        ? `${t('shipping:ORDER_BEFORE_X_AND_WE_SHIP_TODAY_WINTER_TIME')}`
        : `${t('shipping:ORDER_BEFORE_X_AND_WE_SHIP_TODAY_SUMMER_TIME')}`
    }
    if (shipIsTomorrow) {
      return `${t('shipping:ORDER_TODAY_AND_WE_SHIP_TOMORROW')}`
    }

    return null
  }, [isWintertime, t])

  return <>{getShowOrderBeforeText()}</>
}
